export default "__VITE_ASSET__DoRo9l5P__"